import createReadyHandler from '@/utilities/resolvers/createReadyHandler';

// This utility exports a promise that resolves when Pendo is initialized.
const {
  promise: pendoReadyPromise,
  resolveReady: markPendoReady,
} = createReadyHandler();

export { pendoReadyPromise, markPendoReady };
